import * as joint from "jointjs";
import { withSvgTooltip } from "../tooltips";

export const removeLinkTool = withSvgTooltip(
  new joint.linkTools.Button({
    markup: [
      {
        tagName: "circle",
        selector: "button",
        attributes: {
          r: 7,
          fill: "#35495d",
          cursor: "pointer",
        },
      },
      {
        tagName: "path",
        selector: "icon",
        attributes: {
          d: "M -3 -3 L 3 3 M -3 3 L 3 -3",
          fill: "none",
          stroke: "#FFFFFF",
          "stroke-width": 2,
          "stroke-linecap": "round",
          "pointer-events": "none",
        },
      },
    ],
    distance: 80,
    offset: 10,
    action: function () {
      // @ts-ignore
      this.model.remove();
    },
  }),
  "Delete (Delete/Backspace)",
);
